"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboButton = ComboButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const uuid = __importStar(require("uuid"));
const antd_1 = require("antd");
const defaultProps = {
    type: 'primary',
};
function ComboButton(props) {
    return ((0, jsx_runtime_1.jsx)(antd_1.Dropdown.Button, { "data-cy": "edit-offer", ...defaultProps, ...props, overlay: (0, jsx_runtime_1.jsx)(antd_1.Menu, { children: props.menu.map(menuItem => ((0, jsx_runtime_1.jsx)(antd_1.Menu.Item, { "data-cy": "menu-offer", onClick: menuItem.onClick, disabled: menuItem.disabled, children: menuItem.label }, uuid.v4()))) }), children: props.children }));
}
